// ** React Imports
import { useState, useEffect, useContext } from 'react'

// ** Custom Components
import Avatar from '@components/avatar'

// ** Store & Actions
import { useDispatch } from 'react-redux'

// ** Utils
import { formatDateToMonthShort, isObjEmpty } from '@utils'

// ** Third Party Components
import PerfectScrollbar from 'react-perfect-scrollbar'
import { X, Search, CheckSquare, Bell, User, Trash } from 'react-feather'

// ** Reactstrap Imports
import { CardText, InputGroup, InputGroupText, Badge, Input, Button, Label } from 'reactstrap'

import useApi from '@hooks/useApi'
import useLoader from '@hooks/useLoader';
import useWs from '@hooks/useWS'
import { AuthContext } from '@context/AuthContext'
import SocketActions from "./actions"

import css from '@mstyle/style.module.css'

const SidebarLeft = props => {

    // ** Props & Store
    const { store, sidebar, handleSidebar, userSidebarLeft, handleUserSidebarLeft, handleChatModal } = props

    const { userDetail } = useContext(AuthContext)

    // Loader
	const { fetchData } = useLoader({})

    const ChatApi = useApi().chat

    // ** Dispatch
    const dispatch = useDispatch()

    // ** State
    const [query, setQuery] = useState('')
    const [about, setAbout] = useState('')
    const [filteredChat, setFilteredChat] = useState([])
    const [filteredContacts, setFilteredContacts] = useState([])
    const [filteredSearchChat, setFilteredSearchChat] = useState([])
    const [contacts, setContacts] = useState([])

    const formatData = (prev, newData) =>
    {
        const chatList = [...prev]

        chatList.find(chat =>
            {
                if(chat?.roomId === newData.roomId && userDetail.id != newData.user)
                {
                    chat.contact.lastChat.chat = newData?.message
                    chat.contact.lastChat.isMe = false
                    chat.contact.timestamp = newData?.timestamp
                    chat.contact.unreadChatCount = chat?.contact?.unreadChatCount + 1
                }
            })
        return chatList
    }

    const {data, setData, isSocketConnected, socketSend} = useWs({
        roomId: undefined,
        action: {
            /** Тухайн өрөөнд ирсэн socket чат дата хадгалах */
            [SocketActions.MESSAGE]: {
                initData: [],
                format: formatData
            },
            /** Online хэрглэгчийн жагсаалтын сонсох нь */
            [SocketActions.ONLINE_USER]: {
                initData: [],
                format: (prev, newData) =>
                {
                    return newData?.userList ?? []
                }
            },
        },
    })

    const onlineUsers = data[SocketActions.ONLINE_USER]
    const chats = data[SocketActions.MESSAGE]

    /** socket connect хийгдэх үед ашиглана  */
    useEffect(
        () =>
        {
            if(isSocketConnected)
            {
                /** Тухайн хэрэглэгчийн уншаагүй чатны тоог сонсох */
                socketSend({
                    action: SocketActions.GET_ONLINE_USER,
                    user: userDetail?.id,
                    roomId: null,
                })
            }
        },
        [isSocketConnected]
    )

    // ** Handles User Chat Click
    const handleUserClick = (id, type) => {
        handleChatModal(id, type)
    }

    useEffect(() => {
        getRoomsData()
    }, [])

    /** hook set data */
    const setChats = (data) =>
    {
        setData((prev) =>
        {
            prev['message'] = data
            return prev
        })
    }

    async function getRoomsData()
    {
        const {success, data} = await fetchData(ChatApi.getRooms())
        if(success)
        {
            setChats(data)
        }
    }

    // ** Renders Chat
    const renderChats = () => {
        if (chats && chats.length) {
            if (query.length && !filteredChat.length) {
                return (
                    <li className='no-results show'>
                        <h6 className='mb-0'>Хэрэглэгч байхгүй байна</h6>
                    </li>
                )
            } else {
                const arrToMap = query.length && filteredChat.length ? filteredChat : chats

                return arrToMap.map((item, index) => {
                    const time = item?.contact?.timestamp ? formatDateToMonthShort(item?.contact?.timestamp) : null
                    const isMe = item?.contact?.lastChat.isMe ? 'Та:' : ''
                    return (
                        <li className='border-bottom mb-50' style={{display: 'flex'}} key={index} role="button" onClick={() => handleUserClick(item?.sId, 'DM') }>
                            {
                                item.contact?.avatar && item.contact?.avatar !== ''
                                ?
                                    <Avatar
                                        img={item.contact.avatar}
                                        imgHeight='32'
                                        imgWidth='32'
                                        status = {
                                            onlineUsers.includes(item.sId)
                                            ?
                                                "online"
                                            :
                                                "offline"
                                        }
                                        style={{ width: '32px', height: '32px' }}
                                        />
                                :
                                    <Avatar
                                        initials
                                        color = {'light-success'}
                                        content = {item.contact.fullName || ''}
                                        contentStyles = {{
                                            borderRadius: 0,
                                        }}
                                        style={{ width: '32px', height: '32px' }}
                                    />
                            }
                            <div className='chat-info flex-grow-1 mb-1' >
                                <h5 className={`mb-0 ms-1 ${css.cchatMobile} ${item?.contact?.unreadChatCount > 0 ? css.boldText : null}`} >{item.contact.fullName}</h5>
                                <CardText className='w-90 ms-1'>
                                    <span className={`d-inline-block text-truncate ${css.cchatMobile} ${item?.contact?.unreadChatCount > 0 ? css.boldText : null}`}>
                                        {isMe} {item?.contact?.lastChat.chat}
                                    </span>
                                </CardText>
                            </div>
                            <div className='text-wrap d-flex flex-column align-items-start mt-0'>
                                <small className={`float-end chat-time ${item?.contact?.unreadChatCount > 0 ? css.boldText : null}`}>{time}</small>
                                {
                                    item?.contact?.unreadChatCount > 0
                                    ?
                                        <div className='w-100'>
                                            <Badge className='float-end' color='danger' pill>
                                                {item?.contact?.unreadChatCount}
                                            </Badge>
                                        </div>
                                    :
                                        null
                                }
                            </div>
                        </li>

                    )
                })
            }
        } else {
            return null
        }
    }

    // ** Renders Contact
    const renderContacts = () => {
        if (contacts && contacts.length) {
        if (query.length && !filteredContacts.length) {
            return (
                <li className='no-results show'>
                    <h6 className='mb-0'>No Chats Found</h6>
                </li>
            )
        } else {
            const arrToMap = query.length && filteredContacts.length ? filteredContacts : contacts
            return arrToMap.map(item => {
                return (
                    <li key={item.fullName} onClick={() => handleUserClick(item.id, 'DM')}>
                        <Avatar img={item.avatar} imgHeight='42' imgWidth='42' />
                        <div className='chat-info flex-grow-1'>
                            <h5 className='mb-0'>{item.fullName}</h5>
                            <CardText className='text-truncate'>{item.about}</CardText>
                        </div>
                    </li>
                )
            })
        }
        } else {
        return null
        }
    }

    // ** Handles Filter
    // const handleFilter = e => {
    //     setQuery(e.target.value)

    //     const {success, data} = await fetchData(schoolApi.get())
    //     if(success) {
    //         setSchools(data)
    //     }
    //     // const searchFilterFunction = contact => contact.fullName.toLowerCase().includes(e.target.value.toLowerCase())
    //     // const filteredChatsArr = chats.filter(searchFilterFunction)
    //     // const filteredContactssArr = contacts.filter(searchFilterFunction)
    //     // setFilteredChat([...filteredChatsArr])
    //     // setFilteredContacts([...filteredContactssArr])
    // }

    /* Жагсаалтын дата авах функц */
    async function handleFilter(e) {
        //TODO: debounce оруулах
        setQuery(e.target.value)
        const {success, data} = await fetchData(ChatApi.searchUser(e.target.value.toLowerCase()))
        if(success) {
            setFilteredSearchChat(data)
        }
    }

    const searchChats = () => {
        if (query.length)
        {
            if (query.length && (!filteredSearchChat || !filteredSearchChat.length))
            {
                return (
                    <div>
                        <h5 className={` mt-50 ${css.cchatTitle}`}>Хайлтын илэрц</h5>
                        <ul className={`${css.userChatList} chat-list media-list`}>
                            <li className='no-results show'>
                                <h6 className='mb-0'>Хайлтын утга олдсонгүй</h6>
                            </li>
                        </ul>
                    </div>
                )
            }
            else
            {
                const arrToMap = query.length && filteredChat.length ? filteredChat : filteredSearchChat
                return(
                    <div>
                        <h5 className={` mt-50 ${css.cchatTitle}`}>Хайлтын илэрц</h5>
                        <ul className={`${css.userChatList} chat-list media-list`}>
                            {
                                arrToMap.map((item, index) => {
                                    // const time = formatDateToMonthShort(item.chat.lastMessage ? item.chat.lastMessage.time : new Date())
                                    return (
                                        <li style={{display: 'flex'}} key={index} role="button" onClick={() => handleUserClick(item?.sId, 'DM')}>
                                            <div className='mb-1'>
                                                {
                                                    item?.avatar && item?.avatar !== ''
                                                    ?
                                                        <Avatar img={item.avatar} imgHeight='32' imgWidth='32' />
                                                    :
                                                        <Avatar
                                                            initials
                                                            color = {'light-success'}
                                                            content = {item?.first_name || ''}
                                                            contentStyles = {{
                                                                borderRadius: 0,
                                                            }}
                                                            // status="online"
                                                            style={{ width: '32px', height: '32px' }}
                                                        />
                                                }
                                            </div>
                                            <div className='chat-info d-flex align-items-center ms-1 mb-1' >
                                                <h5 className='mb-0'>{item?.first_name} {item?.last_name}</h5>
                                            </div>
                                        </li>
                                    )
                                    })
                            }
                        </ul>
                    </div>
                )
            }
        }
        else {
            return null
        }
    }

    const renderAboutCount = () => {
        if (userProfile && userProfile.about && userProfile.about.length && about.length === 0) {
        return userProfile.about.length
        } else {
        return about.length
        }
    }

    return (
        <div>
            <div className='chat-fixed-search'>
                <div className='mt-1 d-flex align-items-center w-100'>
                <InputGroup className='input-group-merge w-100'>
                    <InputGroupText className='round'>
                        <Search className='text-muted' size={14} />
                    </InputGroupText>
                    <Input
                        value={query}
                        className='round'
                        placeholder='Хайх'
                        onChange={handleFilter}
                    />
                    </InputGroup>
                </div>
            </div>
            <div>
            <PerfectScrollbar className='chat-user-list-wrapper list-group' options={{ wheelPropagation: false }}>
                {searchChats()}
                <h5 className={`mt-50 ${css.cchatTitle}`}>Хувийн</h5>
                <ul className={`${css.userChatList} chat-list media-list ps-1`}>{renderChats()}</ul>
                <h5 className={`${css.cchatTitle}`}>Бүлгийн</h5>
                <ul className={`${css.userChatList} contact-list media-list`}>{renderContacts()}</ul>
            </PerfectScrollbar>
            </div>
        </div>
    )}

export default SidebarLeft
